import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';
import { get } from 'lodash';
import { maxTextLength } from '@utils/utils';

export default [
  {
    label: 'Číslo rámu',
    field: 'frameNumber',
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Datum a čas registrace',
    field: 'regDatetime',
    type: ColumnType.DATETIME,
    width: 80,
    compact: true
  },
  {
    label: 'Datum a čas platnosti registrace',
    field: 'regValidDatetime',
    type: ColumnType.DATETIME,
    width: 80,
    compact: true
  },
  {
    label: 'Barva',
    field: 'color.name',
    displayField: 'color',
    mapper: parent => get(parent, 'name'),
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Značka',
    field: 'brand.name',
    displayField: 'brand',
    mapper: parent => get(parent, 'name'),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Majitel',
    field: 'owner.name',
    displayField: 'owner',
    mapper: parent => get(parent, 'fullName'),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Poznámka',
    field: 'note',
    mapper: parent => maxTextLength(parent, 20),
    type: ColumnType.TEXT,
    width: 200
  }
];

export const photosGridColumns = [{ label: 'Název', field: 'name', type: ColumnType.TEXT, width: 80 }];



// WEBPACK FOOTER //
// ./src/modules/bicycles/_bicyclesColumns.ts